var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"bg-gray"},[_c('EntityPaginationRouter',{attrs:{"linkGenerator":_vm.generateUrl,"entities":_vm.feedTanks,"paginationText":_vm.paginationText,"badgeText":_vm.badgeText}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }